/**
 * The system stack every pairing falls back to.
 *
 * Not decoration: a variable font that fails to load must land on something a
 * reader can read rather than on the browser's serif default, and the fallback
 * is what a page shows in the moment before the face arrives.
 */
const SANS_FALLBACK = `-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif`;
const MONO_FALLBACK = `ui-monospace, SFMono-Regular, Menlo, monospace`;
export const FONT_PAIRINGS = [
    {
        id: 'geist',
        label: 'Geist',
        character: 'The developer-tool default: neutral, tight, and invisible. What this product uses itself.',
        sans: `'Geist Variable', 'Geist', ${SANS_FALLBACK}`,
        mono: `'Geist Mono Variable', 'Geist Mono', ${MONO_FALLBACK}`,
    },
    {
        id: 'humanist',
        label: 'Humanist',
        character: 'Warmer and rounder, for documentation that is read rather than scanned. Code stays technical.',
        sans: `'Work Sans Variable', 'Work Sans', ${SANS_FALLBACK}`,
        mono: `'JetBrains Mono Variable', 'JetBrains Mono', ${MONO_FALLBACK}`,
    },
    {
        id: 'system',
        label: 'System',
        character: 'Whatever the reader’s device uses. Nothing to download, and it looks native everywhere.',
        /**
         * No web font at all, which is a real answer rather than an absence: a
         * reader on a slow connection gets text immediately, and a customer whose
         * own brand already lives in the operating system's face gets it for free.
         */
        sans: SANS_FALLBACK,
        mono: MONO_FALLBACK,
    },
];
export const DEFAULT_FONTS = 'geist';
/**
 * A stored name, or the default — the forgiving half.
 *
 * Reading is forgiving where writing is strict, and the direction matters: a
 * row written by an older version, or naming a pairing since retired, must
 * still BUILD a site rather than failing the publish of documentation that has
 * nothing wrong with it. `fontsProblem` is the strict half, and it runs where
 * the value is stored.
 */
export function fontsOrDefault(value) {
    return FONT_PAIRINGS.some((pairing) => pairing.id === value) ? value : DEFAULT_FONTS;
}
/**
 * A name from the list, or a sentence naming the list.
 *
 * The same shape as `codeThemeProblem` and `presetProblem`, and for the reason
 * that one gives: a value from outside the set must be refused where it is
 * stored rather than swallowed and quietly ignored.
 */
export function fontsProblem(value) {
    if (!FONT_PAIRINGS.some((pairing) => pairing.id === value)) {
        return {
            ok: false,
            problem: `"${value}" is not a font pairing. Choose one of: ${FONT_PAIRINGS.map((p) => p.id).join(', ')}.`,
        };
    }
    return { ok: true, value };
}
//# sourceMappingURL=fonts.js.map